/**
 * Broadhead lander front-end scripts.
 */

/**
 * YouTube facade: swap the static poster for the real iframe on first click.
 *
 * The PHP filter (APM_Broadhead::clean_youtube_embed) renders each YouTube
 * embed as a <button class="bhc-yt" data-bhc-yt="PLAYER_URL"> holding only a
 * poster image — no YouTube script loads until the visitor interacts.
 */
(function () {
	"use strict";

	function activate(facade) {
		var url = facade.getAttribute("data-bhc-yt");

		if (!url) {
			return;
		}

		var iframe = document.createElement("iframe");

		iframe.className = "bhc-yt__iframe";
		iframe.setAttribute("src", url);
		iframe.setAttribute("title", facade.getAttribute("aria-label") || "YouTube video player");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute(
			"allow",
			"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
		);
		iframe.setAttribute("allowfullscreen", "");

		facade.parentNode.replaceChild(iframe, facade);
		iframe.focus();
	}

	function init() {
		var facades = document.querySelectorAll("[data-bhc-yt]");

		Array.prototype.forEach.call(facades, function (facade) {
			// If the HD poster is missing, fall back to the always-present one.
			var poster = facade.querySelector(".bhc-yt__poster");

			if (poster) {
				poster.addEventListener("error", function () {
					if (poster.src.indexOf("maxresdefault") !== -1) {
						poster.src = poster.src.replace("maxresdefault", "hqdefault");
					}
				});
			}

			facade.addEventListener("click", function () {
				activate(facade);
			});
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();

/**
 * Toggle an `is-at-top` class on <body> while the page is scrolled to the top,
 * removing it as soon as the visitor scrolls away.
 */
(function () {
	"use strict";

	var ticking = false;
	var wasAtTop = null;

	/**
	 * Ease the looping .bhc-pulse animation back to its resting state instead of
	 * letting it snap. Browsers don't reliably transition OUT of a removed
	 * infinite animation — they revert transform/opacity to base instantly. So we
	 * FLIP it: capture the live animated frame, drop the animation, pin that frame
	 * inline in the SAME tick (no paint = no snap), then release one frame later so
	 * the stylesheet's transition carries it from the frame to rest.
	 */
	function easePulseToRest() {
		var els = document.querySelectorAll(".bhc-pulse");
		if (!els.length) {
			return;
		}

		var frames = [];
		els.forEach(function (el) {
			var cs = window.getComputedStyle(el);
			frames.push({ transform: cs.transform, opacity: cs.opacity });
		});

		// Remove the animation and immediately pin the captured frame, synchronously,
		// so the browser never renders the intermediate snap-to-base.
		document.body.classList.remove("is-at-top");
		els.forEach(function (el, i) {
			el.style.transition = "none";
			el.style.transform = frames[i].transform;
			el.style.opacity = frames[i].opacity;
		});

		// Commit the pinned frame, then release to the resting state with the
		// stylesheet transition (.bhc-pulse { transition: ... }) driving the ease.
		void document.body.offsetWidth;
		window.requestAnimationFrame(function () {
			els.forEach(function (el) {
				el.style.transition = "";
				el.style.transform = "";
				el.style.opacity = "";
			});
		});
	}

	function update() {
		var atTop = window.pageYOffset <= 0;

		if (wasAtTop && !atTop) {
			// Leaving the top: wind the pulse down smoothly (handles class removal).
			easePulseToRest();
		} else {
			document.body.classList.toggle("is-at-top", atTop);
		}

		wasAtTop = atTop;
		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			ticking = true;
			window.requestAnimationFrame(update);
		}
	}

	function init() {
		update();
		window.addEventListener("scroll", onScroll, { passive: true });
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
